import get from 'lodash/fp/get'
import pipe from 'lodash/fp/pipe'

export const getFileGeneratorPlotData = pipe(get('fileGeneratorPlot'))
